import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cuenta-creada',
  templateUrl: './cuenta-creada.component.html',
  styleUrls: ['./cuenta-creada.component.css']
})
export class CuentaCreadaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
